import { Component, Input } from '@angular/core';
import { AppCopyDirective } from '../../../../../../shared/directives/copy.directive';
import { DateFormatPipe } from '../../../../../../shared/pipes/dateFormatPipe';
import { DefaulValuePipe } from '../../../../../../shared/pipes/defaultValuePipe';
import { Trust } from '@models/trusts/trust';
import { TrustStatusPipe } from "../../../../../../shared/pipes/trustStatusPipe";
import { ABNPipe } from '../../../../../../shared/pipes/abnPipe';
import { TrustSubTypePipe } from "../../../../../../shared/pipes/trustSubTypePipe";
import { stateLabelsDictionary } from "../../../../../../shared/constants/au-states.constant";
import { JurisdictionType } from "@models/trusts/trusts-enums";
import { DatepickerHelper } from "../../../../../../shared/validators/date-picker-form-validators";

@Component({
  selector: 'app-trust-details',
  standalone: true,
  templateUrl: 'trust-details.component.html',
  styleUrl: 'trust-details.component.scss',
  imports: [
    ABNPipe,
    DateFormatPipe,
    DefaulValuePipe,
    AppCopyDirective,
    TrustStatusPipe,
    TrustSubTypePipe,
  ]
})
export class TrustDetailsComponent {
  @Input() trustProfile!: Trust;

  get jurisdiction(): string {
    return stateLabelsDictionary[JurisdictionType[this.trustProfile.jurisdiction!]] ?? '-';
  }

  get variationDates(): string {
    if (this.trustProfile.variationDates.length)
      return this.trustProfile.variationDates
        .map((date) => DatepickerHelper.toString(date))
        .join(', ');
    return '-';
  }
}
